<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('pages.kakao-chennel-partner-view')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card title="파트너 운영 정보" class="mb-4">
          <b-form-group label-cols="2" horizontal label="사업자번호" class="weight600">
            <b-form-input plaintext :value="bizNumber"></b-form-input>
          </b-form-group>
          <b-form-group label-cols="2" horizontal label="카카오톡 채널" class="weight600">
            <b-form-input plaintext :value="getChannelInfo()"></b-form-input>
          </b-form-group>
          <b-form-group v-if="currentUser.userRole == 'BRAND_ADMIN'" label-cols="2" horizontal label="연동신청 매장" class="weight600">
            <b-row>
              <b-colxx xxs="12" xl="8">
                <b-table-simple class="table b-table text-center" responsive show-empty>
                  <b-thead class="thead-light">
                    <b-tr>
                      <b-th>매장</b-th>
                      <b-th>매장 운영상태</b-th>
                      <b-th>장소정보</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="(item, idx) in kakaoStoreList" :key="idx">
                      <b-td class="align-middle">{{ item.storeName }}</b-td>
                      <b-td class="align-middle">
                        <h6 v-if="item.enabled" class="mb-0"><span class="badge badge-confirm">활성화</span></h6>
                        <h6 v-else class="mb-0"><span class="badge badge-disabled">비활성화</span></h6>
                      </b-td>
                      <b-td>
                        <h6 v-if="item.storePartnerLinkStatus === 'LINKED'" class="mb-0">
                          <span class="badge badge-confirm">연동중</span>
                        </h6>
                        <h6 v-else-if="item.storePartnerLinkStatus === 'REQUEST' && !allBrand" class="mb-0">
                          <span class="badge badge-disabled">등록대기</span>
                        </h6>
                        <h6 v-else class="mb-0">
                          <b-button size="xs" variant="outline-primary" @click="locationModalOpen(item)">등록</b-button>
                        </h6>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-colxx>
            </b-row>
          </b-form-group>
          <b-form-group v-else label-cols="2" horizontal label="장소정보" class="weight600">
            <h6 class="mb-0" v-if="kakaoStoreList.storePartnerLinkStatus === 'LINKED'">
              <span class="badge badge-confirm">연동중</span>
            </h6>
            <h6 class="mb-0" v-else>
              <b-button size="sm" variant="outline-primary" @click="locationModalOpen(kakaoStoreList)">등록</b-button>
            </h6>
          </b-form-group>
        </b-card>

        <!--  장소등록 모달 start  -->
        <b-modal id="locationReg" ref="locationReg" size="xl" :hide-backdrop="false" :no-close-on-backdrop="true">
          <template slot="modal-title">
            <span>장소등록</span>
          </template>
          <template slot="modal-header-close">
            <b-button squared size="xs" variant="primary" class="mr-auto" @click="goToStore">매장정보 수정하기</b-button>
          </template>
          <b-form-group label-cols="2" horizontal class="weight600 " id="storeStatus" label="매장운영상태">
            <div class="align-content-center h-100">{{ locationInfo.enable ? '활성화' : '비활성화' }}
              <span class="text-danger" v-if="!locationInfo.enable">활성화 상태 매장만 등록 가능합니다.<br>
                                                                  [매장정보 > 전시관리 > 전시여부]를 변경해 주세요.
            </span>
            </div>
          </b-form-group>
          <b-form-group label-cols="2" horizontal class="weight600 " id="storeStatus" label="예약 카테고리">
            <div class="input-group d-flex mb-3" v-for="idx in categoryLength+1" style=" width: 70%">
              <select class="form-control mr-3 col-4" v-model="dep1Selected[idx-1]"
                      @change="dep1Change(dep1Selected[idx-1],idx-1 )">
                <option v-for="(dp1Cate, dp1Idx) in kakaoCategoryList" :value="dp1Cate">
                  {{ dp1Cate.categoryName }}
                </option>
              </select>
              <select class="form-control mr-3 col-4" v-model="selectedCategoryList[idx-1]">
                <option v-for="(dp2Cate, dp2Idx) in dep2ArrList[idx-1]" :value="dp2Cate.categoryCode">
                  {{ dp2Cate.categoryName }}
                </option>
              </select>
              <button class="btn btn-outline-success" style="padding-top: 0px; padding-bottom: 0px;"
                      v-if="categoryLength == 1" @click="removeReserveCategory(idx-1)"> 삭제
              </button>
              <button class="btn btn-outline-success" style="padding-top: 0px; padding-bottom: 0px;"
                      v-if="categoryLength == 0" @click="addReserveCategory">추가
              </button>
            </div>
          </b-form-group>
          <b-form-group label-cols="2" horizontal class="weight600 " id="storeStatus" label="장소 대표 이미지">
            <b-form-row>
              <sortable-file-uploader :compact="true" :max-files="1" :container="'STORE'"
                                      @getFileData="onMainImage"></sortable-file-uploader>
            </b-form-row>
            <div class="align-content-center mt-2">
              • 권장 사이즈 800x800px / 파일당 최대 20MB / jpeg, jpg, png, gif<br>
              • 상호명, 간판, 로고, 매장 사진 등 장소 관련 이미지로 등록해 주세요.<br>
              • 미등록 시 매장 기본정보에 등록된 대표이미지로 대체되어 등록됩니다.<br>
            </div>
          </b-form-group>
          <b-form-group label-cols="2" horizontal class="weight600 " id="storeStatus" label="장소명">
            <b-form-input class="col-4" placeholder="" type="text" v-model="placeName"></b-form-input>
          </b-form-group>
          <b-form-group label-cols="2" horizontal class="weight600 " id="storeStatus" label="주소">
            <div class="align-content-center mb-3">
              {{ `(${locationInfo.zipCode}) ${locationInfo.address} ${locationInfo.detailAddress}` }}
            </div>
            <div class="d-flex mb-3">
              <label class="align-content-center font-weight-bold mr-2">카카오맵 장소 아이디</label>
              <b-form-input class="col-2" size="sm" placeholder="" type="text" v-model="placeId"></b-form-input>
            </div>
            <div class="align-content-center ">1. Kakao Map 접속 (<a href="https://map.kakao.com" target="_blank"
                                                                   style="color: #007bff">https://map.kakao.com</a>)<br>
              2. 매장 장소 검색<br>
              3. 좌측 검색결과에서 해당 장소에 “상세보기” 클릭<br>
              4. 연결된 URL에 기재된 장소아이디 확인하여 입력 (https://place.map.kakao.com/{장소아이디})<br>
              ex) https://place.map.kakao.com/14559670 > 카카오맵 장소 아이디에 “14559670” 입력<br>
            </div>
          </b-form-group>
          <b-form-group label-cols="2" horizontal class="weight600 " id="storeStatus" label="대표전화">
            <div class="align-content-center h-100">
              {{ locationInfo.phoneNumber }}
              <span class="text-danger" v-if="!locationInfo.phoneNumber">매장 대표전화 정보가 없습니다.<br>
                                                                      [매장정보 > 매장 등록 정보]에서 등록해 주세요.
            </span>
            </div>
          </b-form-group>
          <b-form-group label-cols="2" horizontal class="weight600 " id="storeStatus" label="사업자번호">
            <div class="align-content-center h-100">{{ locationInfo.registrationNumber }}</div>
          </b-form-group>
          <b-form-group label-cols="2" horizontal class="weight600 " id="autoBooking" label="일반예약 승인">
            <div class="d-flex">
              <b-form-radio-group v-model="locationInfo.autoBooking" >
                <b-form-radio :value="false" disabled>대기</b-form-radio>
                <b-form-radio :value="true" disabled>실시간</b-form-radio>

              </b-form-radio-group>
              <span class="text-danger" v-if="!locationInfo.autoBooking">실시간 승인만 가능합니다.<br>
                                            [매장정보 > 예약 기본 설정]에서 수정해 주세요.
              </span>
            </div>
          </b-form-group>
          <b-form-group label-cols="2" horizontal class="weight600 " id="paidAutoBooking" label="결제예약 승인">
            <div class="d-flex">
              <b-form-radio-group v-model="locationInfo.paidAutoBooking">
                <b-form-radio :value="false" disabled>대기</b-form-radio>
                <b-form-radio :value="true" disabled>실시간</b-form-radio>
              </b-form-radio-group>
              <span class="text-danger" v-if="!locationInfo.paidAutoBooking">실시간 승인만 가능합니다.<br>
                                          [매장정보 > 예약 기본 설정]에서 수정해 주세요.
              </span>
            </div>

          </b-form-group>
          <b-form-group label-cols="2" horizontal class="weight600 " id="dayAutoBooked" label="익일 자동 방문완료">
            <div class="d-flex">
              <b-form-radio-group v-model="locationInfo.dayAutoBooked">
                <b-form-radio :value="true" disabled>사용</b-form-radio>
                <b-form-radio :value="false" disabled>미사용</b-form-radio>

              </b-form-radio-group>
              <span class="text-danger" v-if="!locationInfo.dayAutoBooked">자동 방문완료 처리는 필수입니다.<br>
                                          [매장정보 > 예약 기본 설정]에서 수정해 주세요.
            </span>
            </div>

          </b-form-group>
          <b-form-group v-if="locationInfo.menuInfo !==null ||locationInfo.menuInfo.length>0" label-cols="2"
                        horizontal class="weight600 " id="storeStatus" label="메뉴">
            <b-table-simple
              class="table b-table text-center"
              responsive
              show-empty
            v-if="locationInfo.menuInfo.length>0"
            >
              <b-thead class="thead-light">
                <b-tr>
                  <b-th>메뉴명</b-th>
                  <b-th>정상가</b-th>
                  <b-th>대표메뉴</b-th>

                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(item, idx) in locationInfo.menuInfo" :key="idx">
                  <b-td>{{ item.menuName }}</b-td>
                  <b-td>{{ item.listPrice }}</b-td>
                  <b-td>{{ item.mainMenu ? 'O' : '' }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <span class="text-danger" v-if="locationInfo.menuInfo.length==0">등록된 메뉴가 없습니다.<br>
                                          [매장정보 > 메뉴관리]에서 메뉴를 1개이상 등록해 주세요.
                </span>
          </b-form-group>
          <template slot="modal-footer">
            <div class="justify-content-center">
              <b-button variant="outline-primary" @click="locationModalHide('modalbackdrop')">취소</b-button>
              <b-button variant="primary" class="mr-1" @click="addLocation">장소등록</b-button>
            </div>
          </template>
        </b-modal>
        <!--  장소등록 모달 END  -->

        <b-card title="파트너 기본 정보">
          <b-form-group label-cols="2" horizontal label="파트너명(업체명)" class="weight600">
            <b-form-input maxlength="50" v-model="name"></b-form-input>
            <span class="text-length-label">{{ getTextLength(name) }} / 50 자</span>
          </b-form-group>
          <b-form-group label-cols="2" horizontal label="사업자명" class="weight600">
            <b-form-input plaintext :value="bizInfo.name"></b-form-input>
          </b-form-group>
          <b-form-group label-cols="2" horizontal label="대표자명" class="weight600">
            <b-form-input plaintext :value="bizInfo.representativeName"></b-form-input>
          </b-form-group>
          <b-form-group label-cols="2" horizontal label="업태" class="weight600">
            <b-form-input plaintext :value="bizInfo.businessCategory"></b-form-input>
          </b-form-group>
          <b-form-group label-cols="2" horizontal label="종목" class="weight600">
            <b-form-input plaintext :value="bizInfo.businessCategoryItem"></b-form-input>
          </b-form-group>
          <b-form-group label-cols="2" horizontal label="주소" class="weight600">
            <b-row>
              <b-colxx xxs="12" xl="8">
                <b-row class="mb-1">
                  <b-colxx xxs="6" class="pr-0">
                    <b-form-input type="text" v-model="bizInfo.zipcode" disabled></b-form-input>
                  </b-colxx>
                  <b-colxx xxs="6" class="pl-1">
                    <b-button variant="outline-primary default" @click="searchAddress">주소검색</b-button>
                    <modal_postcode ref="modal_postcode" @confirm="selectAddress" />
                  </b-colxx>
                </b-row>
                <b-row>
                  <b-colxx xxs="6" class="pr-0">
                    <b-form-input type="text" v-model="bizInfo.baseAddress" disabled></b-form-input>
                  </b-colxx>
                  <b-colxx xxs="6" class="pl-1">
                    <b-form-input type="text" v-model="bizInfo.detailAddress"></b-form-input>
                  </b-colxx>
                </b-row>
              </b-colxx>
            </b-row>
          </b-form-group>
          <b-row class="mt-4 justify-content-center">
            <b-button variant="outline-primary" class="mr-1" @click="back">취소</b-button>
            <b-button variant="success" @click="updateKakaoReserveStore">정보수정</b-button>
          </b-row>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>


<script>

import api from "@/constants/api";
import {mapGetters} from "vuex";
import modal_image from "@/views/shop/components/ModalImage.vue";
import {ContainerClient} from "@azure/storage-blob";
import modal_postcode from "@/views/shop/components/ModalPostcode.vue";
import SortableFileUploader from "@/components/Upload/SortableFileUploader.vue";


export default {
  components: {'sortable-file-uploader': SortableFileUploader, modal_postcode, modal_image},
  data() {
    return{
      phoneData: false,
      kakaoId: 0,

      tmpData:{},
      storeName : "",
      storeCode:"",
      token:"",
      kakaoChannelList:[],
      kakaoStoreList:null,
      storeListData:[],
      selectedKakaoChannel:"",
      partnerName: "",
      businessName: "",
      businessCode: "",
      representativeName:"",
      businessCategory:"",
      businessCategoryItem:"",
      zonecode:"",
      address:"",
      detailAddress:"",
      bizNameNum: 0,
      selectedStore:[],
      bizNumber:"",
      channelId:0,
      channelSearchId:"",
      channelName:"",
      allBrand: true,
      createdAt:"",
      name:"",
      operationStatus:"",
      kakaoStatus:"",
      updateAt: "",
      bizInfo: {
        name:"",
        representativeName: "",
        businessCategory:"",
        businessCategoryItem:"",
        zipcode: "",
        baseAddress: "",
        detailAddress:"",
      },
      locationToggle:false,
      addCategory : false,
      categoryLength: 0,
      kakaoCategoryList:[],
      dep1Selected:[
      ],
      dep2ArrList:[
        [{categoryCode:"2차 선택",
          categoryName:"2차 선택",
          categoryNum:0
        }]
      ],
      selectedCategoryList: ["2차 선택"],
      mainImageurl:"",
      image:null,
      locationInfo:{
        storeCode	: "", //	String	스토어코드
        enable	: false, //	Boolean	활성상태
        basis	: "", //	String	정산 기준가
        commissionRate	: "", //	String	정산수수료
        brandName	: "", //	String	브랜드명
        storeName	: "", //	String	스토어명
        address	: "", //	String	주소
        detailAddress	: "", //	String	상세주소
        zipCode	: "", //	String	우편번호
        phoneNumber	: "", //	String	전화번호
        registrationNumber	: "", //	String	사업자번호
        autoBooking	: false, //	Boolean	일반예약 자동 예약 승인 여부
        paidAutoBooking	: false, //	Boolean	결제예약 자동 예약 승인 여부
        dayAutoBooked	: false, //	Boolean	익일자동 방문완료 처리 여부
        menuInfo	: [], //	arr	메뉴정보
        //       menuInfo[].listPrice	:””, //	String	정상가
        //       menuInfo[].menuName	:””, //	String	메뉴명
        //   menuInfo[].mainMenu	:””, //	Boolean	메인메뉴여부
      },
      regLocationInfo: null,
      placeName:"",
      placeId:"",
      partnerId:""


    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName','info'])

  },
  watch:{
    'smsRegisterDocumentUrl'(value) {
      console.log(value);
      this.browseText1 = this.smsRegisterDocumentUrl == null ? '등록' : "수정"

      if (value.type != undefined) {
        const azureInfo = this.AzureFileUpload1();
        console.log(azureInfo)
      }
    },
    'smsCertificateDocumentUrl'(value) {
      console.log(value);
      this.browseText2 = this.smsCertificateDocumentUrl == null ? '등록' : "수정"

      if (value.type != undefined) {
        const azureInfo = this.AzureFileUpload2();
        console.log(azureInfo)
      }
    },
    'businessCode'(val){
      val = val.replace(/[^0-9]/g, '').replace(/^(\d{3,3})(\d{2,2})(\d{0,5})$/, `$1-$2-$3`)
      this.businessCode = val
    },


  },
  created() {
    // if(this.currentUser.userRole != "BRAND_ADMIN"){
    //   if(this.$route.query.storeCode !=null && this.$route.query.storeCode !=undefined && this.$route.query.storeCode != '' ){
    //     this.storeCode = this.$route.query.storeCode
    //     this.chkStore();
    //   }else{
    //     this.storeCode = this.info.storeCode
    //     this.chkStore();
    //   }
    // }else{
    //   this.storeCode = this.$route.query.storeCode
    //   this.chkStore();
    // }
    // if(this.$route.query.reg !=null && this.$route.query.reg !=undefined && this.$route.query.reg != '' ){
    //   this.regCode = this.$route.query.reg
    // }
    this.kakaoId = this.$route.query.kakaoId
    this.partnerId = this.$route.query.partnerId
    console.log(this.kakaoId)
  },
  beforeMount() {

  },
  mounted() {

    console.log("aa")
    this.getKakaoCategoryList();
    this.getBrandStoreInKakaoReserve();

    this.getKakaoPartnerViewDetail();


  },
  methods:{
    // chkStore(){
    //   let reqURL = ''
    //   reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.getStoreInfo+`?storeCode=${this.storeCode}`)
    //   let params = {"storeCode": this.storeCode}
    //   this.$http.get(reqURL,params,  {
    //     headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
    //   }).then(res => {
    //     // ;
    //     if (res.data.code === "OK") {
    //       this.storeName = res.data.data.basicInfo.storeName
    //
    //     } else {
    //       throw 400
    //     }
    //   }).catch(err => {
    //     //alert(err.response.data.message);
    //
    //   })
    //
    //
    // },


    getChannelInfo() {
      return this.channelName + " (" + this.channelSearchId + ")";
    },
    getTextLength(str) {
      return (!str || str.length === 0) ? 0 : str.length;
    },
    back(){
      this.$router.go(-1)
    },
    updateKakaoReserveStore(){
      if(!this.partnerName || this.partnerName.length>50){
        alert("파트너명(업체명)을 입력해주세요.")
        return
      } else if(!this.zonecode || !this.address || !this.detailAddress){
        alert("주소를 입력해주세요.")
        return
      }
      let brandInfo = JSON.parse(sessionStorage.getItem("BRAND_INFO"))
      const params = {
        storeCodes : this.currentUser.userRole ==  "BRAND_ADMIN" ? this.selectedStore: [sessionStorage.getItem("storeCode")], //스토어 코드 리스트
        kakaoId: this.kakaoId,
        partnerName : this.name, // 파트너이름
        bizNumber : this.bizNumber, // 사업자번호
        bizName : this.bizInfo.name, // 사업자명
        representativeName: this.bizInfo.representativeName, // 대표자명
        zipCode: this.bizInfo.zipcode,
        baseAddress: this.bizInfo.baseAddress,
        detailAddress: this.bizInfo.detailAddress,
        businessCategory: this.bizInfo.businessCategory,
        businessCategoryItem: this.bizInfo.businessCategoryItem,
        channelSearchId: this.channelSearchId,
        channelId:this.channelId,
        channelName: this.channelName,
        status: this.kakaoStatus
      }

      let reqURL = ''
      if(confirm("파트너 정보를 수정하시겠습니까?")){
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.updateKakaoReserveStore)
        this.$http.post(reqURL,params,  {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {
            alert("수정되었습니다.");
            this.getKakaoPartnerViewDetail();
            this.getBrandStoreInKakaoReserve();
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);

        })
      }

    },
    mainIntroLength(eve){
      this.mainIntroNum = eve.srcElement._value.length
    },
    bizNameLength(eve){
      this.bizNameNum = eve.srcElement._value.length
    },
    searchAddress() {
      this.$refs.modal_postcode.open()
    },
    selectAddress(data) {
      this.bizInfo.detailAddress = data.data.detailAddress
      this.bizInfo.baseAddress = data.data.roadAddress
      this.bizInfo.zipcode = data.data.zipCode
    },
    initKakaoPartner(){
      this.partnerName = this.selectedKakaoChannel.name
    },

    //
    getBrandStoreInKakaoReserve(){
      this.kakaoStoreList = null

      let reqURL = ''
      if (this.currentUser.userRole === 'BRAND_ADMIN') {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.getKakaoLinkedStoreListBRD + `?partnerId=${this.partnerId}`)

      }else{
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.getKakaoLinkedStoreListSTR + `?kakaoId=${this.kakaoId}`)
      }
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          this.kakaoStoreList = res.data.data;
          this.getAllBrand();
        } else {
          throw 400
        }
      }).catch(err => {
        this.kakaoChannelList = []
        alert(err.message);
      })
    },
    getAllBrand() {
      console.log( this.info.brandCode);
      for(let i=0; i<this.kakaoStoreList.length; i++) {
        if(this.kakaoStoreList[i].brandCode != this.info.brandCode) {
          this.allBrand = false;
        }
      }
    },

    getKakaoPartnerViewDetail(){
      let reqURL = ''
      reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.getKakaoPartnerViewDetail+`?kakaoId=${this.kakaoId}`)
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          this.kakaoId = res.data.data.id
          this.bizNumber = res.data.data.bizNumber
          this.channelName = res.data.data.channelName
          this.channelId = res.data.data.channelId
          this.channelSearchId = res.data.data.channelSearchId
          this.name = res.data.data.name
          this.bizInfo = res.data.data.bizInfo
          this.partnerName = res.data.data.channelName
          this.zonecode = res.data.data.bizInfo.zipcode
          this.address = res.data.data.bizInfo.baseAddress
          this.detailAddress = res.data.data.bizInfo.detailAddress
          this.kakaoStatus = res.data.data.status
        } else {
          throw 400
        }
      }).catch(err => {
        this.kakaoChannelList = []
        alert(err.response.data.message);
      })
    },
    locationModalOpen(val){
      this.$refs["locationReg"].show();
      this.regLocationInfo = val;
      let reqURL = ''
      console.log(this.currentUser.userRole)
      if (this.currentUser.userRole === 'BRAND_ADMIN') {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.getKakaoPartnerLocationInfoBRD + `?storeCode=${this.regLocationInfo.storeCode}`)
      }else{
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.getKakaoPartnerLocationInfoSTR)
      }
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          this.placeName = `${res.data.data.brandName} ${res.data.data.storeName}`;
          this.locationInfo = res.data.data
          console.log(this.locationInfo)
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })

    },
    addReserveCategory(){
      this.addCategory = true
      this.categoryLength = 1;
      this.dep1Selected[1] = {
        categoryName: "1차 선택",
        categoryNum: 0,
        subCategoryList:[ {categoryCode:"2차 선택",
          categoryName:"2차 선택",
          categoryNum:0
        }]
      }
      this.dep2ArrList.push(
        [{categoryCode:"2차 선택",
          categoryName:"2차 선택",
          categoryNum:0
        }])
      this.selectedCategoryList.push("2차 선택")
    },
    locationModalHide() { //등록창 취소
      this.selectedCategoryList = []
      this.dep1Selected = []
      this.categoryLength = 0
      this.addCategory = false
      this.placeId = ""
      this.placeName = ""
      this.$refs["locationReg"].hide()
    },
    removeReserveCategory(val){
      this.selectedCategoryList.splice(val,1)
      this.dep1Selected.splice(val,1)
      this.dep2ArrList.splice(val,1)
      this.categoryLength = 0
      this.addCategory = false
    },

    getKakaoCategoryList(){
      let reqURL = ''
      reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.getKakaoCategoryList)
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        console.log(res)
        if (res.data.code === "OK") {
          this.kakaoCategoryList = res.data.data.mainCategoryList
          this.kakaoCategoryList.unshift({
            categoryName: "1차 선택",
            categoryNum: 0,
            subCategoryList:[{categoryCode:"2차 선택",
              categoryName:"2차 선택",
              categoryNum:0
            }]
          })
          this.dep1Selected[0] = {
            categoryName: "1차 선택",
            categoryNum: 0,
            subCategoryList:[{categoryCode:"2차 선택",
              categoryName:"2차 선택",
              categoryNum:0
            }]

          }
        } else {
          throw 400
        }
      }).catch(err => {
        this.kakaoCategoryList = []
        alert(err.response.data.message);
      })
    },
    onMainImage(file) {
      if (file.length > 0) {
        let _url = file[0].azureUrl ? file[0].azureUrl : file[0].url;
        this.mainImageurl = _url;
        this.image = {
          width: file[0].width,
          height: file[0].height,
          url: _url,
          azureUrl: _url,
          "description": null
        }
      } else {
        this.mainImageurl = null
      }
    },

    addLocation(){
      let chkCati = this.selectedCategoryList.indexOf("2차 선택")
      if(!this.locationInfo.enable){
        alert("매장 운영상태를 활성화 해주세요.")
        return
      }else if(chkCati > -1){
        alert("예약 카테고리를 선택해주세요.")
        return
      } else if(!this.placeName){
        alert("장소명을 입력해주세요.")
        return
      } else if(!this.placeId){
        alert("카카오맵 장소 아이디를 입력해주세요.")
        return
      } else if(!this.locationInfo.phoneNumber){
        alert("매장 대표전화 정보가 없습니다.")
        return
      } else if(!this.locationInfo.autoBooking){
        alert("일반예약 승인은 실시간만 가능합니다.")
        return
      } else if(!this.locationInfo.paidAutoBooking){
        alert("결제예약 승인은 실시간만 가능합니다.")
        return
      } else if(!this.locationInfo.dayAutoBooked){
        alert("익일 자동 방문완료 처리는 필수입니다.")
        return
      } else if(this.locationInfo.menuInfo.length == 0){
        alert("등록된 메뉴가 없습니다.")
        return
      }else if(!this.locationInfo.basis){
        alert("정산 수수료 정보가 없습니다. 테이블엔조이에 문의 요망.")
        return
      }

      let reqData= {
          storeCode:this.locationInfo.storeCode, //string
          categoryList:this.selectedCategoryList, //arr
          imageUrl: this.mainImageurl, //string
          placeId: this.placeId, //string
          placeName:this.placeName, //string
        }
      let reqURL = ''
      if (this.currentUser.userRole === 'BRAND_ADMIN') {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.regKakaoLocationInfoBRD)
      }else{
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.regKakaoLocationInfoSTR)
      }

      this.$http.post(reqURL,reqData,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          this.selectedCategoryList = []
          this.dep1Selected = []
          this.categoryLength = 0
          this.addCategory = false
          this.dep1Selected[0] = {
            categoryName: "1차 선택",
            categoryNum: 0,
            subCategoryList:[ {categoryCode:"2차 선택",
              categoryName:"2차 선택",
              categoryNum:0
            }]
          }
          this.placeId = ""
          this.placeName = ""
          alert("장소등록이 완료되었습니다.")
          this.$forceUpdate()
          this.$router.push(`${'/'+this.siteName+'/booking/outer-connect-mng'}`)
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })

    },
    goToStore(){
      this.$router.push(`${'/'+this.siteName+'/shop/edit-shop/'+this.regLocationInfo.storeCode}`)
    },
    dep1Change(val,idx){
      this.dep2ArrList[idx] = val.subCategoryList
    }

  }
}
</script>

<style>
.close{
  opacity: 1;
}
.modal-footer{
  justify-content: center !important;
}
</style>
